import { render, staticRenderFns } from "./OpcCurveSettingsPopover.vue?vue&type=template&id=705250c4&scoped=true&"
import script from "./OpcCurveSettingsPopover.vue?vue&type=script&lang=js&"
export * from "./OpcCurveSettingsPopover.vue?vue&type=script&lang=js&"
import style0 from "./OpcCurveSettingsPopover.vue?vue&type=style&index=0&id=705250c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705250c4",
  null
  
)

export default component.exports